// extracted by mini-css-extract-plugin
module.exports = {"card":"b429494557--card--d0v6d","preview":"b429494557--preview--bny8B","description":"b429494557--description--CfUtv","description-text":"b429494557--description-text--f7Exb"};